<section class="mp-details" *ngIf="profile">
    <!-- SECTION 0 -->
    <div class="mp-titlebar">
        <div class="left-head">
            <span class="user-img editable">
                <img [src]="photoUrl" id="img_SetupUsersProfilePhoto">

                <div class="user-img__overlay" (click)="photoOptions.toggle($event)">
                    <i class="fa-regular fa-camera"></i>
                </div>
            </span>

            <p-menu #photoOptions styleClass="user-img-menu" [popup]="true" [model]="photoMenuItems" appendTo="body"></p-menu>
            <div class="mp-headline">
                <!-- Name -->
                <div class="flex-align-center gap-2">
                    <h1 class="mp-title" id="label_SetupUsersFullName">{{profile.firstName}} {{profile.lastName}}</h1>
                    <span class="mp-chip mp-chip--success" id="label_SetupUsersStatusActive" *ngIf="profile?.status == 'ACTIVE'">{{translate?.general.status.active.singular}}</span>
                    <span class="mp-chip" id="label_SetupUsersStatusSuspended" *ngIf="profile?.status == 'SUSPENDED'">{{translate?.general.status.suspended.singular}}</span>
                    <span class="mp-chip" id="label_SetupUsersStatusDeactivated" *ngIf="profile?.status == 'DEACTIVE'">{{translate?.general.status.deactivated.singular}}</span>
                    <span class="mp-chip" id="label_SetupUsersStatusPendingActivation" *ngIf="profile?.status == 'PENDING_ACTIVATION'">{{translate?.general.status.pendingActivation.singular}}</span>
                </div>
                <!-- Order Owner name -->
                <div class="mp-subtitle">
                    <span class="mp-subtitle__text" id="value_SetupUsersProfileName">{{profile.profileName || '-'}}</span>
                </div>
                <div class="mp-subtitle mt-0">
                    <span class="mp-subtitle__text" id="value_SetupUsersEmail">{{profile.email || '-'}}</span>
                </div>
            </div>
        </div>

        <div class="mp-titlebar__chips">

            
            <!-- Status actions: same rules as view-user (not shown on own profile) -->
            <ng-container *ngIf="params?.id != auth.getUserId()">
                <p-button *ngIf="profile?.status == 'SUSPENDED' || profile?.status == 'DEACTIVE'"
                    [label]="translate?.general.status.activate.singular"
                    id="btn_SetupUsersActivate"
                    styleClass="h-32 btn-status-activate"
                    (onClick)="openStatusAction('activateUser')"></p-button>
               
               <p-button *ngIf="profile?.status == 'ACTIVE'"
                    [label]="translate?.general.status.suspend.singular"
                    id="btn_SetupUsersSuspend"
                    styleClass="h-32 danger"
                    (onClick)="openStatusAction('suspendUser')"></p-button>
                    
                <button class="custella-btn-white" id="btn_SetupUsersDeactivate" *ngIf="profile?.status != 'DEACTIVE'"
                    (click)="openStatusAction('deactivateUser')">{{translate?.general.status.deactivate.singular}}</button>
            </ng-container>

            <!-- Top actions hidden when DEACTIVE (same as view-user) -->
            <ng-container *ngIf="profile?.status != 'DEACTIVE'">
                <p-button *ngIf="profile?.status == 'ACTIVE'"
                    [label]="translate?.general.buttons.resetPassword.singular"
                    id="btn_SetupUsersResetPassword"
                    styleClass="h-32 dark"
                    (onClick)="resetPassword()"></p-button>
                <p-button *ngIf="profile?.status == 'PENDING_ACTIVATION'"
                    [label]="translate?.general.buttons.resendEmail.singular"
                    id="btn_SetupUsersResendEmail"
                    styleClass="h-32 dark"></p-button>
                <p-button *ngIf="canEditUser" [label]="translate?.general.buttons.edit.singular" id="btn_SetupUsersEdit" styleClass="h-32" (onClick)="goToEditUser()"></p-button>
            </ng-container>
        </div>
    </div>


    <div class="mp-grid">
        <!-- Left Side -->
        <article class="mp-card">
            <!-- Personal Info -->
            <header class="mp-card__header">
                <div class="w-icon">
                    <i class="fa-regular fa-file-circle-info"></i>
                    <h2 id="label_SetupUsersPersonalInfoTitle">{{translate?.setup.users.users.sections.sec0.singular}}</h2>
                </div>
            </header>
            <div class="mp-card__body">
                <dl class="mp-def">
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersFirstName">{{ translate?.setup.users.users.fields.firstName.singular  }} :</dt>
                        <dd id="value_SetupUsersFirstName">{{profile.firstName || '-'}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersLastName">{{ translate?.setup.users.users.fields.lastName.singular  }} :</dt>
                        <dd id="value_SetupUsersLastName">{{profile.lastName || '-'}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersEmail">{{ translate?.setup.users.users.fields.email.singular  }} :</dt>
                        <dd id="value_SetupUsersEmailField">{{profile.email || '-'}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersPhone">{{ translate?.setup.users.users.fields.phone.singular  }} :</dt>
                        <dd id="value_SetupUsersPhone">{{profile.phone || '-'}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersHomeAddress">{{translate?.setup.users.users.sections.sec12.singular}} :</dt>
                        <dd id="value_SetupUsersHomeAddress">{{homeAddressDisplay}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersOfficeAddress">{{translate?.setup.users.users.sections.sec13.singular}} :</dt>
                        <dd id="value_SetupUsersOfficeAddress">{{officeAddressDisplay}}</dd>
                    </div>
                   
                </dl>
            </div>

            <!-- Login Details -->
            <header class="mp-card__header mp-card__header--sub">
              <div class="w-icon">
                <i class="fa-regular fa-user-lock"></i>
                <h2 id="label_SetupUsersLoginDetailsTitle">{{translate?.setup.users.users.sections.sec17.singular}}</h2>
              </div>
            </header>
            <div class="mp-card__body">
                <dl class="mp-def">
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersUsername">{{ translate?.setup.users.users.fields.username.singular  }} :</dt>
                        <dd id="value_SetupUsersUsername">{{profile.login || '-'}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersUserType">User Type:</dt>
                        <dd id="value_SetupUsersUserType">{{profile.userType?.name || '-'}}</dd>
                    </div>
                </dl>
            </div>

            <!-- Employment Details -->
            <header class="mp-card__header mp-card__header--sub">
              <div class="w-icon">
                <i class="fa-regular fa-briefcase"></i>
                <h2 id="label_SetupUsersEmploymentDetailsTitle">Employment Details</h2>
              </div>
            </header>
            <div class="mp-card__body">
                <dl class="mp-def">
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersDesignation">Designation :</dt>
                        <dd id="value_SetupUsersDesignation">{{profile.designation || profile.profileName || '-'}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersEmployeeNo">{{translate?.setup.users.users.fields.employeeNo.singular}}:</dt>
                        <dd id="value_SetupUsersEmployeeNo">{{profile.employeeNo || '-'}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersManager">{{translate?.setup.users.users.fields.manager.singular}} :</dt>
                        <dd id="value_SetupUsersManager">{{managerName}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersServiceZone">{{translate?.setup.serviceZone.label.singular}} :</dt>
                        <dd id="value_SetupUsersServiceZone">{{profile.serviceZone?.name || '-'}}</dd>
                    </div>
                </dl>
            </div>
            
            <!-- Access and Hierarchy -->
            <header class="mp-card__header mp-card__header--sub">
              <div class="w-icon">
                <i class="fa-regular fa-key-skeleton-left-right"></i>
                <h2 id="label_SetupUsersAccessHierarchyTitle" *ngIf="hideBaseOnPackage.hierarchy">{{translate?.setup.users.access.label.singular}} {{translate?.general.messages.andLower}} {{translate?.setup.users.hierarchy.label.singular}}</h2>
                <h2 id="label_SetupUsersAccessOnlyTitle" *ngIf="!hideBaseOnPackage.hierarchy">{{translate?.setup.users.access.label.plural}}</h2>
              </div>
            </header>
            <div class="mp-card__body">
                <dl class="mp-def">
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersProfile">{{translate?.setup.users.access.label.singular}} :</dt>
                        <dd
                            class="link"
                            id="value_SetupUsersProfile"
                            *ngIf="profile?.profileId; else noAccessProfile"
                            (click)="viewAccessProfile()">
                            {{profile.profileName || '-'}}
                        </dd>
                        <ng-template #noAccessProfile>
                            <dd id="value_SetupUsersProfile">{{profile.profileName || '-'}}</dd>
                        </ng-template>
                    </div>
                    <div class="mp-def__row" *ngIf="hideBaseOnPackage.hierarchy">
                        <dt id="label_SetupUsersRole">{{translate?.setup.users.hierarchy.label.singular}} :</dt>
                        <dd class="link" id="value_SetupUsersRole">{{profile.roleName || '-'}}</dd>
                    </div>
                </dl>
            </div>

            <!-- Preferences -->
            <header class="mp-card__header mp-card__header--sub">
              <div class="w-icon">
                <i class="fa-regular fa-business-time"></i>
                <h2 id="label_SetupUsersPreferencesTitle">{{translate?.setup.users.users.sections.sec8.singular}}</h2>
              </div>
            </header>
            <div class="mp-card__body">
                <dl class="mp-def">
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersTimeZone">{{translate?.setup.users.users.fields.timeZone.singular}} :</dt>
                        <dd id="value_SetupUsersTimeZone">{{profile.timezone || '-'}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersDateFormat">{{translate?.setup.users.users.fields.dateFormat.singular}} :</dt>
                        <dd id="value_SetupUsersDateFormat">{{profile.dateFormatString || '-'}}</dd>
                    </div>
                    <div class="mp-def__row" *ngIf="currentPackage == 'Old'">
                        <dt id="label_SetupUsersDefaultLanguage">{{translate?.setup.users.users.fields.defaultLanguage.singular}} :</dt>
                        <dd id="value_SetupUsersDefaultLanguage">{{profile.language || '-'}}</dd>
                    </div>
                    <div class="mp-def__row" *ngIf="!displayNewJO2">
                        <dt id="label_SetupUsersDefaultMobileView">{{translate?.setup.users.users.fields.defaultMobileView.singular}} :</dt>
                        <dd id="value_SetupUsersDefaultMobileView">{{profile.defaultDashboard || '-'}}</dd>
                    </div>
                     <div class="mp-def__row">
                        <dt id="label_SetupUsersCalendarColorCode">Calendar Color Code :</dt>
                        <dd id="value_SetupUsersCalendarColorCode">
                            <span class="color-swatch" [style.background-color]="profile.calendarColorCode || '#D9D9D9'"></span>
                        </dd>
                    </div>
                    
                </dl>
            </div>

            <!-- System Information -->
            <header class="mp-card__header mp-card__header--sub">
                <div class="w-icon">
                    <i class="fa-regular fa-database"></i>
                    <h2 id="label_SetupUsersSystemInfoTitle">{{translate?.general.systemInformation.sections.sec0.singular}}</h2>
                </div>
            </header>
            <div class="mp-card__body sys-info">
                <dl class="mp-def">
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersCreatedBy">{{translate?.general.systemInformation.fields.createdBy.singular}}:</dt>
                        <dd id="value_SetupUserscreatedByUser">{{profile.createdByUser?.fullName}}, {{profile.createdDate | momentDate : ' hh:mm a' : timezone}},&nbsp;{{profile?.createdDate | momentDate : dateFormat : timezone}}</dd>
                    </div>
                    <div class="mp-def__row">
                        <dt id="label_SetupUsersLastModifiedBy">{{translate?.general.systemInformation.fields.lastModifiedBy.singular}}:</dt>
                        <dd id="value_SetupUserslastModifiedByUser">{{profile.lastModifiedByUser?.fullName}}, {{profile.lastModifiedDate | momentDate : ' hh:mm a' : timezone}},&nbsp;{{profile?.lastModifiedDate | momentDate : dateFormat : timezone}}</dd>
                    </div>
                </dl>
            </div>
        </article>



        <!-- Right Side -->
        <div class="mp-col-right">
            <!-- Skills -->
            <article class="mp-card" *ngIf="hideBaseOnPackage.skill">
                 <header class="mp-card__header">
                    <div class="w-icon">
                        <i class="fa-regular fa-puzzle"></i>
                        <h2 id="label_SetupUsersSkillsTitle">{{translate?.setup.users.skills.label.plural}}</h2>
                    </div>
                    <p-button [label]="translate?.general.buttons.add.singular" icon="fa-regular fa-plus" id="btn_SetupUsersAddSkill" styleClass="h-28" (onClick)="openModal('manageSkills', profile)"></p-button>
                </header>
                <div class="mp-card__body mp-card__body--p-0">
                    
                    <div class="skill-chips" *ngIf="hasSkills">
                        <span
                            class="skill-chip"
                            id="value_SetupUsersSkillChip"
                            *ngFor="let skill of assignedUserSkills"
                            [ngStyle]="getSkillChipStyles(skill)">
                            {{ skill?.label || skill?.name || skill }}
                        </span>
                    </div>
                    <div class="mp-table__empty-state" *ngIf="!hasSkills">
                        <img src="../../../../assets/svg/empty-state-rev.svg" alt="No Records Found" id="img_SetupUsersSkillsEmpty" />
                        <p id="label_SetupUsersSkillsEmptyMessage">{{translate?.general.messages.noHave}} {{translate?.setup.users.skills.label.singular}} {{translate?.general.messages.addedYet}}.</p>
                    </div>
                </div>
            </article>
            
             <!-- User Groups -->
            <article class="mp-card" >
                 <header class="mp-card__header">
                    <div class="w-icon">
                        <i class="fa-regular fa-people-group"></i>
                        <h2 id="label_SetupUsersUserGroupsTitle">{{translate?.setup.users.users.label.singular}} {{translate?.setup.users.groups.label.singular}}</h2>
                    </div>
                    <p-button [label]="translate?.general.buttons.add.singular" icon="fa-regular fa-plus" id="btn_SetupUsersAddUserGroup" styleClass="h-28" (onClick)="openModal('manageUserGroup',profile)"></p-button>
                </header>
                <div class="mp-card__body mp-card__body--p-0">
                     <!-- HAS DATA -->
                    <ul class="mp-group-list" *ngIf="hasUserGroups">
                        <li class="mp-group-list__row" *ngFor="let group of assignedUserGroups">
                            <span class="mp-group-list__name" id="value_SetupUsersUserGroupName">{{ group?.name || group }}</span>
                            <a href="javascript:void(0)" class="mp-group-list__remove" id="btn_SetupUsersRemoveUserGroup" (click)="removeUserGroup(group)">{{translate?.general.buttons.remove.singular}}</a>
                        </li>
                       </ul>
                     <!-- Empty state when user dont have data -->
                    <div class="mp-table__empty-state" *ngIf="!hasUserGroups">
                        <img src="../../../../assets/svg/empty-state-rev.svg" alt="No Records Found" id="img_SetupUsersUserGroupsEmpty" />
                        <p id="label_SetupUsersUserGroupsEmptyMessage">{{translate?.general.messages.noHave}} {{translate?.setup.users.users.label.singular}} {{translate?.setup.users.groups.label.singular}} {{translate?.general.messages.addedYet}}.</p>
                    </div>
                </div>
            </article>



            <!-- Login History -->
            <article class="mp-card" >
                 <header class="mp-card__header">
                    <div class="w-icon">
                        <i class="fa-regular fa-rectangle-history-circle-user"></i>
                        <h2 id="label_SetupUsersLoginHistoryTitle">Login History</h2>
                    </div>
                </header>
                <div class="mp-card__body mp-card__body--p-0">
                    <div class="mp-table-two mp-table--3">
                        <div class="mp-table-two__head" *ngIf="loginHistory?.length">
                            <div id="label_SetupUsersLoginHistoryDateCol">Login Date</div>
                            <div id="label_SetupUsersLoginHistoryIpCol">IP Address</div>
                            <div class="text-center" id="label_SetupUsersLoginHistoryDeviceCol">Device ID</div>
                        </div>
                        <div class="mp-table-two__row" *ngFor="let login of loginHistory">
                            <div id="value_SetupUsersLoginHistoryDate">{{ login.loginDate | date:'dd/MM/yyyy, hh:mm a' }}</div>
                            <div id="value_SetupUsersLoginHistoryIp">{{ login.ipAddress || '-' }}</div>
                            <div class="text-center" id="value_SetupUsersLoginHistoryDevice">{{ login.deviceId || '-' }}</div>
                        </div>
                        <div class="p-3 text-muted text-12" id="label_SetupUsersLoginHistoryEmpty" *ngIf="!loginHistory?.length">No login history</div>
                    </div>
                </div>
            </article>

            <!-- Shifts -->
            <article class="mp-card" *ngIf="displayNewJO2 && displayNewWORKFLOW2" >
                <header class="mp-card__header">
                    <div class="w-icon">
                        <i class="fa-regular fa-user-clock"></i>
                        <h2 id="label_SetupUsersShiftsTitle">{{translate?.setup.users.shifts.label.plural}}</h2>
                    </div>
                    <p-button [label]="translate?.general.buttons.view.singular" id="btn_SetupUsersViewShifts" styleClass="h-28" (onClick)="viewShifts()"></p-button>
                </header>
                
                <div class="mp-card__body mp-card__body--p-0">
                    <div class="mp-table-two-4col mp-table-two-4col--equal" *ngIf="userShifts?.length">
                        <div class="mp-table-two-4col__head">
                            <div id="label_SetupUsersShiftTypeCol">{{translate?.setup.users.shifts.fields.type.singular}}</div>
                            <div id="label_SetupUsersShiftEffStartCol">{{translate?.setup.users.shifts.fields.effStart.singular}}</div>
                            <div id="label_SetupUsersShiftEffEndCol">{{translate?.setup.users.shifts.fields.effEnd.singular}}</div>
                            <div class="text-center" id="label_SetupUsersShiftStatusCol">{{translate?.setup.users.shifts.fields.status.singular}}</div>
                        </div>
                        <div class="mp-table-two-4col__row" *ngFor="let shift of userShifts">
                            <div id="value_SetupUsersShiftType">{{ shift.shiftType }}</div>
                            <div id="value_SetupUsersShiftEffStart">{{ shift.effStart }}</div>
                            <div id="value_SetupUsersShiftEffEnd">{{ shift.effEnd }}</div>
                            <div class="text-center">
                                <span class="mp-chip mp-chip--success" *ngIf="shift.shiftTypeStatus === 'ACTIVE'" id="tag_SetupUsersShiftActive">
                                    {{translate?.general.status.active.singular}}
                                </span>
                                <span class="mp-chip" *ngIf="shift.shiftTypeStatus === 'INACTIVE'" id="tag_SetupUsersShiftInactive">
                                    {{translate?.general.status.inactive.singular}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="p-3 text-muted text-12" id="label_SetupUsersShiftsEmpty" *ngIf="!userShifts?.length">No shifts assigned</div>
                </div>
            </article>
            
            <!-- Working Hours -->

                 <article class="mp-card" >
                 <header class="mp-card__header">
                    <div class="w-icon">
                        <i class="fa-regular fa-user-clock"></i>
                        <h2 id="label_SetupUsersWorkingHoursTitle">{{translate?.setup.general.workingHours.label.singular}}</h2>
                    </div>
                    <p-button [label]="translate?.general.buttons.edit.singular" id="btn_SetupUsersEditWorkingHours" styleClass="h-28" (onClick)="openModal('manageWorkingHours', profile)"></p-button>
                </header>
                
                <div class="mp-card__body mp-card__body--p-0" >
                    
                     <ul class="mp-working-hours" *ngIf="profile?.userCalendar">
                        <li class="mp-working-hours__row">
                            <span class="mp-working-hours__day" id="label_SetupUsersMondayLabel">{{ translate?.setup.general.workingHours.fields.monday.singular }}</span>
                            <span class="mp-working-hours__time" id="value_SetupUsersMondayHours" *ngIf="!profile?.userCalendar?.mondayAllDay">
                                {{ profile.userCalendar.mondayStart | momentDate : ' hh:mm a' : timezone }} - {{ profile.userCalendar.mondayEnd | momentDate : ' hh:mm a' : timezone }}
                            </span>
                            <span class="mp-working-hours__time" id="value_SetupUsersMondayAllDay" *ngIf="profile?.userCalendar?.mondayAllDay">{{ translate?.setup.general.workingHours.fields.allDay.singular }}</span>
                        </li>
                        <li class="mp-working-hours__row">
                            <span class="mp-working-hours__day" id="label_SetupUsersTuesdayLabel">{{ translate?.setup.general.workingHours.fields.tuesday.singular }}</span>
                            <span class="mp-working-hours__time" id="value_SetupUsersTuesdayHours" *ngIf="!profile?.userCalendar?.tuesdayAllDay">
                                {{ profile.userCalendar.tuesdayStart | momentDate : ' hh:mm a' : timezone }} - {{ profile.userCalendar.tuesdayEnd | momentDate : ' hh:mm a' : timezone }}
                            </span>
                            <span class="mp-working-hours__time" id="value_SetupUsersTuesdayAllDay" *ngIf="profile?.userCalendar?.tuesdayAllDay">{{ translate?.setup.general.workingHours.fields.allDay.singular }}</span>
                        </li>
                        <li class="mp-working-hours__row">
                            <span class="mp-working-hours__day" id="label_SetupUsersWednesdayLabel">{{ translate?.setup.general.workingHours.fields.wednesday.singular }}</span>
                            <span class="mp-working-hours__time" id="value_SetupUsersWednesdayHours" *ngIf="!profile?.userCalendar?.wednesdayAllDay">
                                {{ profile.userCalendar.wednesdayStart | momentDate : ' hh:mm a' : timezone }} - {{ profile.userCalendar.wednesdayEnd | momentDate : ' hh:mm a' : timezone }}
                            </span>
                            <span class="mp-working-hours__time" id="value_SetupUsersWednesdayAllDay" *ngIf="profile?.userCalendar?.wednesdayAllDay">{{ translate?.setup.general.workingHours.fields.allDay.singular }}</span>
                        </li>
                        <li class="mp-working-hours__row">
                            <span class="mp-working-hours__day" id="label_SetupUsersThursdayLabel">{{ translate?.setup.general.workingHours.fields.thursday.singular }}</span>
                            <span class="mp-working-hours__time" id="value_SetupUsersThursdayHours" *ngIf="!profile?.userCalendar?.thursdayAllDay">
                                {{ profile.userCalendar.thursdayStart | momentDate : ' hh:mm a' : timezone }} - {{ profile.userCalendar.thursdayEnd | momentDate : ' hh:mm a' : timezone }}
                            </span>
                            <span class="mp-working-hours__time" id="value_SetupUsersThursdayAllDay" *ngIf="profile?.userCalendar?.thursdayAllDay">{{ translate?.setup.general.workingHours.fields.allDay.singular }}</span>
                        </li>
                        <li class="mp-working-hours__row">
                            <span class="mp-working-hours__day" id="label_SetupUsersFridayLabel">{{ translate?.setup.general.workingHours.fields.friday.singular }}</span>
                            <span class="mp-working-hours__time" id="value_SetupUsersFridayHours" *ngIf="!profile?.userCalendar?.fridayAllDay">
                                {{ profile.userCalendar.fridayStart | momentDate : ' hh:mm a' : timezone }} - {{ profile.userCalendar.fridayEnd | momentDate : ' hh:mm a' : timezone }}
                            </span>
                            <span class="mp-working-hours__time" id="value_SetupUsersFridayAllDay" *ngIf="profile?.userCalendar?.fridayAllDay">{{ translate?.setup.general.workingHours.fields.allDay.singular }}</span>
                        </li>
                        <li class="mp-working-hours__row">
                            <span class="mp-working-hours__day" id="label_SetupUsersSaturdayLabel">{{ translate?.setup.general.workingHours.fields.saturday.singular }}</span>
                            <span class="mp-working-hours__time" id="value_SetupUsersSaturdayHours" *ngIf="!profile?.userCalendar?.saturdayAllDay">
                                {{ profile.userCalendar.saturdayStart | momentDate : ' hh:mm a' : timezone }} - {{ profile.userCalendar.saturdayEnd | momentDate : ' hh:mm a' : timezone }}
                            </span>
                            <span class="mp-working-hours__time" id="value_SetupUsersSaturdayAllDay" *ngIf="profile?.userCalendar?.saturdayAllDay">{{ translate?.setup.general.workingHours.fields.allDay.singular }}</span>
                        </li>
                        <li class="mp-working-hours__row">
                            <span class="mp-working-hours__day" id="label_SetupUsersSundayLabel">{{ translate?.setup.general.workingHours.fields.sunday.singular }}</span>
                            <span class="mp-working-hours__time" id="value_SetupUsersSundayHours" *ngIf="!profile?.userCalendar?.sundayAllDay">
                                {{ profile.userCalendar.sundayStart | momentDate : ' hh:mm a' : timezone }} - {{ profile.userCalendar.sundayEnd | momentDate : ' hh:mm a' : timezone }}
                            </span>
                            <span class="mp-working-hours__time" id="value_SetupUsersSundayAllDay" *ngIf="profile?.userCalendar?.sundayAllDay">{{ translate?.setup.general.workingHours.fields.allDay.singular }}</span>
                        </li>
                    </ul>
                </div>
            </article>

            <!-- Setup Access -->
            <article class="mp-card" *ngIf="currentPackage !== 'Old' || addonFeature?.addonAI == 'AI' || orgSettings?.offlineEnable">
                 <header class="mp-card__header">
                    <div class="w-icon">
                        <i class="fa-regular fa-desktop-arrow-down"></i>
                        <h2 id="label_SetupUsersSetupAccessTitle">{{translate?.setup.label.singular}} {{translate?.setup.users.access.label.singular}}</h2>
                    </div>
                    <p-button [label]="translate?.general.buttons.edit.singular" id="btn_SetupUsersEditSetupAccess" styleClass="h-28" (onClick)="openModal('manageSetupAccess', setupAccessModalData)"></p-button>
                </header>
                <div class="mp-card__body mp-card__body--p-0">
                    <dl class="mp-access-list">
                        <div class="mp-access-list__row" *ngIf="currentPackage !== 'Old'">
                            <dt id="label_SetupUsersManageBilling">Manage Billing?</dt>
                            <dd id="value_SetupUsersManageBilling">{{profile.billingUser ? (translate?.general.buttons.yes.singular) : (translate?.general.buttons.no.singular)}}</dd>
                        </div>
                        <div class="mp-access-list__row" *ngIf="addonFeature?.addonAI == 'AI'">
                            <dt id="label_SetupUsersAccessAIFeatures">Access AI Features?</dt>
                            <dd id="value_SetupUsersAccessAIFeatures">{{profile.dailyJobRundown || profile.postJobSummary || profile.taskDurationSuggestion || profile.checklistGeneration ? (translate?.general.buttons.yes.singular) : (translate?.general.buttons.no.singular)}}</dd>
                        </div>
                        <div class="mp-access-list__row" *ngIf="orgSettings?.offlineEnable">
                            <dt id="label_SetupUsersEnableOffline">Enable Offline?</dt>
                            <dd id="value_SetupUsersEnableOffline">{{profile.offlineEnable ? (translate?.general.buttons.yes.singular) : (translate?.general.buttons.no.singular)}}</dd>
                        </div>
                    </dl>
                </div>
            </article>

            <!-- Integrations -->
            <article class="mp-card" >
                 <header class="mp-card__header">
                    <div class="w-icon">
                        <i class="fa-regular fa-desktop-arrow-down"></i>
                        <h2 id="label_SetupUsersIntegrationsTitle">{{translate?.setup.users.access.sections.sec9.singular}}</h2>
                    </div>
                    <p-button *ngIf="hasAnyIntegrationEnabled" [label]="translate?.general.buttons.edit.singular" id="btn_SetupUsersEditIntegrations" styleClass="h-28" (onClick)="openModal('manageIntegrations', profile)"></p-button>
                </header>
                <div class="mp-card__body mp-card__body--p-0" *ngIf="hasAnyIntegrationEnabled">
                    <dl class="mp-access-list">
                        <div class="mp-access-list__row" *ngIf="googleEnable?.enabled">
                            <dt id="label_SetupUsersIntegratesGoogle">{{translate?.setup.users.users.fields.integratesGoogle.singular}}</dt>
                            <dd id="value_SetupUsersIntegratesGoogle">{{ profile?.googleCalenderConnected ? (translate?.general.buttons.yes.singular) : (translate?.general.buttons.no.singular) }}</dd>
                        </div>
                        <div class="mp-access-list__row" *ngIf="microsoftEnable?.enabled">
                            <dt id="label_SetupUsersIntegratesMicrosoft365">{{translate?.setup.users.users.fields.integratesMicrosoft365.singular}}</dt>
                            <dd id="value_SetupUsersIntegratesMicrosoft365">{{ profile?.microsoftCalenderConnected ? (translate?.general.buttons.yes.singular) : (translate?.general.buttons.no.singular) }}</dd>
                        </div>
                        <div class="mp-access-list__row" *ngIf="calendlyEnable?.enabled">
                            <dt id="label_SetupUsersIntegratesCalendly">{{translate?.setup.users.users.fields.integratesCalendly.singular}}</dt>
                            <dd id="value_SetupUsersIntegratesCalendly">{{ profile?.calendlyCalenderConnected ? (translate?.general.buttons.yes.singular) : (translate?.general.buttons.no.singular) }}</dd>
                        </div>
                    </dl>
                </div>
                
                <div class="mp-card__body mp-card__body--p-0" *ngIf="!hasAnyIntegrationEnabled">
                    <p class="p-3 text-12" id="label_SetupUsersIntegrationsEmptyMessage">
                        {{translate?.setup.users.users.messages.noIntegrationsEnabled}}&nbsp;{{translate?.setup.users.users.messages.goTo}}&nbsp;<a class="color-primary" href="javascript:void(0)" id="link_SetupUsersIntegrationsGoTo" (click)="onClickIntegrations()">{{ translate?.setup.users.access.sections.sec9.singular }}</a>&nbsp;{{translate?.setup.users.users.messages.toSetUpOrContactAdmin}}
                    </p>
                </div>
            </article>
        </div>
    </div>
</section>